import React from 'react';
import { SVGProps } from './type';

const Icon = ({ fill }: SVGProps) => {
  return (
    <g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5 3.999c0 -0.276 0.223 -0.5 0.5 -0.5h9.498c0.552 0 1.001 0.447 1.001 0.999v9.999H12.395a1.05 1.05 0 0 0 -1.05 1.048v0.603a3.345 3.345 0 0 1 -3.345 3.346 3 3 0 0 1 -3 -3V4M3 13.497V3.999C3 2.619 4.119 1.5 5.499 1.5h9.498a3 3 0 0 1 3 3v9.998h3.95a1.05 1.05 0 0 1 1.048 1.048c0 3.298 -2.725 5.949 -5.998 5.949H8A5 5 0 0 1 3 16.611H3V13.497m13.996 5.998H12.168a5.325 5.325 0 0 0 1.165 -3h7.543a4.012 4.012 0 0 1 -3.881 3M8 10.498a0.999 0.999 0 1 0 0 1.999h4.998a0.999 0.999 0 1 0 0 -2.001zm-1.001 -3c0 -0.552 0.447 -1.001 0.999 -1.001h5a0.999 0.999 0 1 1 0 2.001H8a0.999 0.999 0 0 1 -1.001 -1.001"
        fill={fill}
      />
    </g>
  );
};

export default Icon;
